<template>
  <div>
    <!-- 默认个性化推荐 -->
    <div class="add">
      <!-- 添加分类 -->
      <el-button type="success" class="AddTheClassification" size="small" @click="add" v-if="isAuth(391)">
        {{ $t("message.AddTheClassification") }}</el-button>
    </div>
    <div class="table">
      <!--     default-expand-all 全部展開 -->
      <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#F0F0F0 ' }" row-key="id">
        <!-- 中文名称 -->
        <el-table-column :label="$t('message.ChineseName')" prop="chinese_name" width="300px">
        </el-table-column>
        <!-- 译文名称 -->
        <el-table-column :label="$t('message.translationName')" align="center" prop="translate_name">
        </el-table-column>
        <!-- 排序 -->
        <el-table-column :label="$t('message.sort')" align="center" prop="sort">
        </el-table-column>
        <!-- 描述 -->
        <el-table-column :label="$t('message.note')" align="center" prop="remark">
        </el-table-column>
        <!--操作  -->
        <el-table-column :label="$t('message.operation')" align="center" width="120px">
          <template slot-scope="scope">
            <div class="a-flex">
              <i class="el-icon-edit" @click="edit(scope.row)" v-if="isAuth(391)"></i>
              <i class="el-icon-delete" @click="hotGoodsGroupDelete(scope.row.id)" v-if="isAuth(392)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 添加编辑分类 -->
    <el-dialog :title="dialogVisibleTitle" :close-on-click-modal="false" :visible.sync="dialogVisible" width="600px"
      center>
      <div class="form">
        <el-form :model="datas" :rules="rules" ref="form" label-width="120px" class="demo-ruleForm">
          <!-- 中文名称： -->
          <el-form-item :label="$t('message.ChineseName') + '：'" prop="chinese_name">
            <el-input v-model="datas.chinese_name" onfocus="this.select()"
              @blur="getCategoryByKeyword('info')"></el-input>
          </el-form-item>
          <!-- 译文名称： -->
          <el-form-item :label="$t('message.translationName') + '：'" prop="translate_name">
            <el-input v-model="datas.translate_name" onfocus="this.select()"></el-input>
          </el-form-item>
          <!-- 排序 -->
          <el-form-item :label="$t('message.sort') + '：'">
            <el-input v-model="datas.sort" onfocus="this.select()"></el-input>
          </el-form-item>
          <!-- 描述： -->
          <el-form-item :label="$t('message.note') + '：'">
            <el-input v-model="datas.remark" onfocus="this.select()"></el-input>
          </el-form-item>
          <!-- 1688分类 -->
          <el-form-item :label="$t('message.classification1688') + '：'">
            <el-select v-model="datas.relation_cate_id" placeholder="请选择" style="width: 100%;" clearable>
              <el-option v-for="item in list1688" :key="item.categoryId" :label="item.chineseName"
                :value="item.categoryId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="dialogVisible = false">{{
        $t("message.cancel")
      }}</el-button>
        <!-- 确定 -->
        <el-button type="primary" @click="hotGoodsGroupSave">{{
        $t("message.save")
          }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      datas: {},
      rules: {
        chinese_name: [
          {
            required: true,
            message: this.$t("message.pleaseChineseName"),
            trigger: "blur",
          },
        ],
        translate_name: [
          {
            required: true,
            message: this.$t("message.pleaseTranslationName"),
            trigger: "blur",
          },
        ],
      },
      dialogVisibleTitle: "",
      dialogVisible: false,
      list1688: []
    };
  },
  created() {
    this.hotGoodsGroup();
  },
  methods: {
    hotGoodsGroup() {
      this.$api.siteConfiguration.hotGoodsGroup().then((res) => {
        this.tableData = res.data;
      });
    },
    // 关键词检索阿里分类
    getCategoryByKeyword(type) {
      let datas = {
        keyword: this.datas.chinese_name,
      }
      this.$api.siteConfiguration.getCategoryByKeyword(datas).then((res) => {
        this.list1688 = res.data;
        if (type == 'info') {
          this.datas.relation_cate_id = ''
        }

      });
    },
    // 新增
    add() {
      this.datas = {
        chinese_name: "",
        translate_name: "",
        remark: "",
        relation_cate_id: '',
      };
      this.dialogVisible = true;
      this.dialogVisibleTitle = "添加-分类";
    },
    // 修改
    edit(item) {
      this.datas = JSON.parse(JSON.stringify(item));
      this.dialogVisible = true;
      this.dialogVisibleTitle = "编辑分类";
      this.getCategoryByKeyword()
    },
    // 删除
    hotGoodsGroupDelete(id) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.save"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.siteConfiguration
            .hotGoodsGroupDelete({ id })
            .then((res) => {
              if (res.code != 0) return this.$message.error(res.msg);
              this.$message.success(res.msg);

              this.hotGoodsGroup();
            });
        })
        .catch(() => { });
    },

    hotGoodsGroupSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.siteConfiguration
            .hotGoodsGroupSave(this.datas)
            .then((res) => {
              this.hotGoodsGroup();
              this.dialogVisible = false;
            });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.add {
  position: absolute;
  top: 25px;
  right: 24px;
  z-index: 999;
}

/deep/.el-table__expand-icon {
  i {
    font-size: 20px;
  }
}

.a-flex {
  display: flex;

  i {
    flex: 1;
    font-size: 20px;
    cursor: pointer;
  }
}

/deep/.el-table__row {
  background-color: #edeff4;
}

.form {
  padding: 20px 10px 10px;
  border-radius: 6px;
  background-color: #edeff4;

  /deep/.el-upload {
    width: 40px;
    height: 40px;
    border: 1px dashed #ccc;
    border-radius: 4px;
  }

  .el-cascader {
    width: 100%;
  }

  .avatar {
    width: 40px;
    height: 40px;
  }
}
</style>